import { action, observable } from 'mobx';

export class PopOverVM {
  @observable popOverOpen: boolean = false;

  @action.bound toggle() {
    this.popOverOpen = !this.popOverOpen;
  }
}
